import * as yup from 'yup';

import { i18n } from '@/plugins/i18n';
import type { FormDto } from '@/services/types/api.types';

const { t } = i18n.global;

// The messages are functions, so they follow the admin's language when it changes.
const field = () => t('map.maxVotes');

export const mapStepValidationSchema = () =>
  yup.object<FormDto>({
    answers: yup.object().shape({
      steps: yup.array().of(
        yup.object().shape({
          map: yup.object().shape({
            maxVotes: yup
              .number()
              .typeError(() => t('validation.invalid_number', { field: field() }))
              .integer(() => t('validation.invalid_integer', { field: field() }))
              .min(1, () => t('validation.min_value', { field: field(), min: 1 }))
              .required(() => t('validation.required', { field: field() })),
          }),
        }),
      ),
    }),
  });
